export const Warnings: Record<string, string> = {
  infant_milk_warning:
    'O Ministério da Saúde informa: o aleitamento materno evita infecções e alergias e é recomendado até os 2 (dois) anos de idade ou mais',
  complementary_feeding_warning:
    'O Ministério da Saúde informa: após os 6 (seis) meses de idade continue amamentando seu filho e ofereça novos alimentos',
};
